<!-- <div class="d-flex align-items-center justify-content-between">
           
            <h3 class="snack-bar-header paragraph_type_2">{{header}}</h3>
            <mat-icon style="transform: scale(2);" color="accent">{{icon}}</mat-icon>
        </div>
        <div class="d-flex align-items-center justify-content-between">

        </div>
        <div [innerHTML]="paragraph" class="d-flex align-items-center justify-content-between mt-2 mb-2"
            style="color:#10384f">

        </div>
        <div class="d-flex align-items-center justify-content-end">
            <button mat-flat-button color="accent" (click)="snackBar.dismiss()">Cerrar</button>
        </div> -->

<mat-card class="mat-card-snack_bar_{{success}}">

    <!-- <div class="d-flex justify-content-end align-items-center cerrar-snack-bar">
        <button matTooltip="Cerrar" mat-icon-button>
            <mat-icon style="color: white;">close</mat-icon>
        </button>
    </div> -->

    <div class="d-flex justify-content-between align-items-center mb-1">
        <h5>
            {{header}}

        </h5>
        
        <!-- <button matTooltip="Cerrar" mat-icon-button>
            <mat-icon style="color: white;">close</mat-icon>
        </button> -->
    </div>

    <mat-card-content>

        {{paragraph}}

    </mat-card-content>

</mat-card>